jQuery( function($) {

    $.fn.isInViewport = function( offset = 0 ) {
		var elementTop = $(this).offset().top + offset;
		var elementBottom = elementTop + $(this).outerHeight();
		var viewportTop = $(window).scrollTop();
		var viewportBottom = viewportTop + $(window).height();
		return elementBottom > viewportTop && elementTop < viewportBottom;
	};

    const elementEntranceFade = () => {
		$.each( $('.ews-animate'), function() {
			var $this = $( this );
			if ( $this.isInViewport()) {
				var delay = $this.attr( 'data-delay' ) || 0;
				var anim  = $this.attr( 'data-animate' ) || 'ews-fade';
                setTimeout( function(){
    				$this
                        .removeClass( 'ews-animate' )
                        .addClass( anim );
                }, delay)
					
			}
		});
	}

    $( document ).on( 'scroll', function() {
        elementEntranceFade()
    }); // Run on scroll
    elementEntranceFade(); // Run on document ready

})